import type { IP2PGraphDataPoint } from './link_budget.types'

// MCS 0 and MCS 5 are excluded — the hardware does not support data at these modulation levels
const UNSUPPORTED_MCS = new Set([0, 5])

/**
 * Filters out unsupported MCS levels and returns the remaining points
 * sorted by MCS descending (highest MCS first) for chart rendering.
 */
export function filterAndSortMcsData(data: IP2PGraphDataPoint[]): IP2PGraphDataPoint[] {
  return [...data]
    .filter(d => !UNSUPPORTED_MCS.has(d.mcs))
    .sort((a, b) => b.mcs - a.mcs)
}
